// extracted by mini-css-extract-plugin
export var searchHeader = "_6b-0";
export var searchHeaderDark = "_6b-1";